import { observer } from 'mobx-react-lite'
import { Box, Divider, Typography } from 'shared/ui'
import { DoubleOptInSettingLayout } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInSetting/DoubleOptInSettingLayout'
import { useSecurityContext } from 'pages/settings/pages/personal/pages/account/pages/security/context/securityContext'
import styles from './styles.module.scss'

export const SecurityPageSettings = observer(() => {
  const { disabled, sms, email, app, toggleSetting, isDisabledSetting, isAllowedToSendSms } =
    useSecurityContext()
  const isSmsOrgLevelEnabled = sms && isDisabledSetting('sms')
  const isEmailOrgLevelEnabled = email && isDisabledSetting('email')

  return (
    <div className={styles.wrapper}>
      <Box marginBottom={'23px'}>
        <Typography
          variant={'body-lg-medium'}
          ariaLabel={'Two factor authentication'}
          color={'var(--content-primary-primary)'}
        >
          Two factor authentication
        </Typography>
        <Typography
          tag={'div'}
          variant={'body-md-regular'}
          ariaLabel='title'
          color='var(--content-primary-tertiary)'
          marginTop={'4px'}
        >
          {isSmsOrgLevelEnabled || isEmailOrgLevelEnabled
            ? 'Two-factor authentication is required for all users in your organization. You’ll need to keep at least one verification method turned on.'
            : 'Select at least one verification method to receive temporary verification codes'}
        </Typography>
      </Box>

      <DoubleOptInSettingLayout
        title={'SMS'}
        description={'Receive a one-time passcode via SMS. US, Canada, and UK numbers only'}
        disabled={disabled || isDisabledSetting('sms') || !isAllowedToSendSms}
        checked={sms}
        onToggle={(value) => toggleSetting('sms', value)}
        className={styles.item}
      />

      <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />

      <DoubleOptInSettingLayout
        title={'Email'}
        description={'Receive a one-time passcode via email'}
        disabled={disabled || isDisabledSetting('email')}
        checked={email}
        onToggle={(value) => toggleSetting('email', value)}
        className={styles.item}
      />

      <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />

      <DoubleOptInSettingLayout
        title={'Authenticator app'}
        description={'Receive a one-time passcode via an authenticator app'}
        disabled={disabled || isDisabledSetting('app')}
        checked={app}
        onToggle={(value) => toggleSetting('app', value)}
        className={styles.item}
      />
    </div>
  )
})
